import { Controller } from '@hotwired/stimulus';

// Size the dialog to the visible area, including keyboard and browser chrome changes.
export default class extends Controller {
  connect() {
    this.dialog = this.element.closest('dialog');
    if (!this.dialog) return;

    this.viewport = window.visualViewport;
    this.update = this.update.bind(this);
    this.viewport?.addEventListener('resize', this.update);
    this.viewport?.addEventListener('scroll', this.update);
    window.addEventListener('resize', this.update);
    this.update();
  }

  disconnect() {
    this.viewport?.removeEventListener('resize', this.update);
    this.viewport?.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
    ['height', 'width', 'top', 'left'].forEach(dimension => {
      this.dialog?.style.removeProperty(`--visual-viewport-${dimension}`);
    });
  }

  update() {
    const dimensions = {
      height: this.viewport?.height ?? window.innerHeight,
      width: this.viewport?.width ?? window.innerWidth,
      top: this.viewport?.offsetTop ?? 0,
      left: this.viewport?.offsetLeft ?? 0
    };
    Object.entries(dimensions).forEach(([dimension, value]) => {
      this.dialog.style.setProperty(`--visual-viewport-${dimension}`, `${value}px`);
    });
  }
}
